import { useCallback } from 'react';
import { prop } from 'ramda';
import { useDispatch } from 'react-redux';
import { useGetBonusContextGames } from 'server';
import { useGetErrorMessage } from 'js/hooks/server/hooks';

import { BONUS_AMOUNT_TYPES } from '../constants';
import { updatePlayableGameTypes } from '../store/actions';
import { useDynamicReducerSelector } from '../store';

export const useGetContextGames = () => {
    const dispatch = useDispatch();
    const getBonusContextGames = useGetBonusContextGames();
    const getErrorMessage = useGetErrorMessage();
    const bonuses = useDynamicReducerSelector(prop('bonuses'));

    return useCallback(async (id: string): Promise<void> => {
        const bonus = bonuses.find((item) => item.remoteBonusId === id && (
            item.playType === BONUS_AMOUNT_TYPES.FREE_SPINS
            || item.playType === BONUS_AMOUNT_TYPES.FREE_SPINS2
            || item.playType === BONUS_AMOUNT_TYPES.GOLDEN_CHIPS)
        );

        try {
            if (bonus && !bonus.playableGameTypes) {
                dispatch(updatePlayableGameTypes({ id, isLoading: true }));

                const { bonusInstanceCode, remoteBonusId } = bonus;
                const { playableGameTypes = [] } = await getBonusContextGames({ bonusInstanceCode, remoteBonusId });

                dispatch(updatePlayableGameTypes({ playableGameTypes, id, isLoading: false }));
            }
        } catch (error: any) {
            dispatch(updatePlayableGameTypes({ error: getErrorMessage(error), id, isLoading: false }));
        }

    }, [bonuses, dispatch, getBonusContextGames, getErrorMessage]);
};
